import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';
import Translation from '../../translation/translation';
import Tooltip from '../../tooltip/tooltip';
import getTranslatedText from '../../../helper/get_translated_text';
import { noop } from '../../../../../lib/utilities';
import { Table } from '../structure/table';

const getDiscountLabel = name => (
    <Tooltip
        label={
            name.match(/^discount-voucher-/)
                ? getTranslatedText(name)
                : name
        }
        content={getTranslatedText('sidebar-discount-tooltip')}
        additionalClassNames={['discount__voucher-type']}
        key='sidebar-discount-type'
    />
);

const getLabelDiscountName = (p, d) => {
    const labelContent = (<>
        <span>{getDiscountLabel(d.name)}</span>

        {p.allowDelete && d.idVoucher && <span style={{ marginLeft: '10px', cursor: 'pointer', verticalAlign: 'middle' }}>
            <svg onClick={(e) => p.onRemoveDiscountClick({ id: d.idVoucher })} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
            </svg>
        </span>}
    </>
    );

    return (
        <Table
            rows={[<Price
                key={d.name}
                name='discount'
                lightLabel={true}
                label={labelContent}
                price={d.amount || 0}
                currencyIsoCode={p.currencyIsoCode}
                hasBorder={false}
                noBottomPadding={true}
                loading={p.loading}
                overrides={p.currencySetupOverrides}
            />]}
        />
    );
};

export const Discount = props => {
    const isNRMA = TYROOLA.globals.store === 'AU_NRMA';

    return <>
        <Price
            name={props.name}
            label={''}
            labelExtraChildren={props.discountInfo.map(d => (getLabelDiscountName(props, d)))}
            colspan={3}
        />
        <tr className="discount--buy-4-pay-3">
            <td className="col-xs-12 voucher-sidebar-style" colSpan="3" style={{ padding: '0' }}>
                <a href="javascript:void(0);" className={`${isNRMA ? 'sidebar-voucher-code-nrma' : ''} sidebar-voucher-code cursor-pointer`} >
                    <Translation translationKey={'checkout-sidebar-voucher-code-text'} />
                </a>
            </td>
        </tr>
    </>
};

Discount.propTypes = {
    discountInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    hasBorder: PropTypes.bool,
    name: PropTypes.string,
    labelExtraChildren: PropTypes.arrayOf(PropTypes.object),
    labelKey: PropTypes.string,
    currencySetupOverrides: PropTypes.object,
    onRemoveDiscountClick: PropTypes.func,
};

Discount.defaultProps = {
    hasBorder: true,
    name: 'discount',
    labelKey: 'pdp-sidebar-discount-label',
    currencySetupOverrides: {},
    onRemoveDiscountClick: noop,
};
